import axios from 'axios'
import qs from 'qs'
import store from '../store'
import { services } from '../services'
import { getConfig } from '../services/runtimeConfig'
import { resolveSfpBaseUrl } from '../sfp/config'
import { guardLegacyOrderCall, legacyError } from '../sfp/cutover'

// Runtime config (settings.json) loads async on bootstrap, so the API hosts are
// only available once requests fire. Resolve each once on the first request and
// reuse it — runtime config can't change without a redeploy.
let apiBaseURL
let dhlBaseURL
let movimenta20BaseURL
let sfpBaseURL

const instance = axios.create({
  headers: {
    requestOrigin: 'DASHBOARD_SUPPLIER',
    'Accept': '*/*'
  },
  paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
})

const _appendResponse = response => services.errorService(response)

// A legacy order call made after the cutover flag turned on is cancelled; the
// dashboard then renders the flow screens.
const _guardLegacyOrderCall = config => guardLegacyOrderCall(config, () => store.dispatch('cutover/refresh'))

const _legacyError = error => legacyError(error, _appendResponse)

instance.interceptors.request.use(config => {
  if (apiBaseURL === undefined) apiBaseURL = getConfig('VUE_APP_API_HOST')
  config.baseURL = apiBaseURL

  const showLoader = store.getters['loading/isFullPage']
  if (showLoader) store.dispatch('loading/start')

  if (store) config.headers['Authorization'] = store.getters['user/authorization']
  return _guardLegacyOrderCall(config)
})

instance.interceptors.response.use(response => {
  store.dispatch('loading/stop')
  return _appendResponse(response)
}, error => {
  store.dispatch('loading/stop')

  // TODO: pick up the error.stack for logs
  return _legacyError(error)
})

const Movimenta20Instance = axios.create({
  headers: {
    requestOrigin: 'DASHBOARD_SUPPLIER',
    'Accept': '*/*'
  },
  paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
})

Movimenta20Instance.interceptors.request.use(config => {
  if (movimenta20BaseURL === undefined) movimenta20BaseURL = getConfig('VUE_APP_MOVIMENTA20_HOST_NAME')
  config.baseURL = movimenta20BaseURL

  const showLoader = store.getters['loading/isFullPage']
  if (showLoader) store.dispatch('loading/start')

  if (store) config.headers['Authorization'] = store.getters['user/authorization']
  return config
})

Movimenta20Instance.interceptors.response.use(response => {
  store.dispatch('loading/stop')
  return _appendResponse(response)
}, error => {
  store.dispatch('loading/stop')
  return _appendResponse(error.response)
})

const DHLLabelInstance = axios.create({
  headers: {
    'Accept': '*/*',
    'Cache-Control': 'no-cache'
  }
})

DHLLabelInstance.interceptors.request.use(config => {
  if (dhlBaseURL === undefined) dhlBaseURL = getConfig('VUE_APP_LABELAPI_DHL')
  config.baseURL = dhlBaseURL

  const showLoader = store.getters['loading/isFullPage']
  if (showLoader) store.dispatch('loading/start')

  return config
})

DHLLabelInstance.interceptors.response.use(response => {
  store.dispatch('loading/stop')
  return _appendResponse(response)
}, error => {
  store.dispatch('loading/stop')
  return _appendResponse(error.response)
})

// The flow's API on the portal's own host; answers keep the errorService shape.
const SfpInstance = axios.create({
  headers: {
    'Accept': '*/*'
  },
  paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true })
})

SfpInstance.interceptors.request.use(config => {
  if (sfpBaseURL === undefined) sfpBaseURL = resolveSfpBaseUrl(getConfig('VUE_APP_SFP_API_URL'), window.location.origin)
  config.baseURL = sfpBaseURL

  const showLoader = store.getters['loading/isFullPage']
  if (showLoader) store.dispatch('loading/start')

  if (store) config.headers['Authorization'] = store.getters['user/authorization']
  return config
})

SfpInstance.interceptors.response.use(response => {
  store.dispatch('loading/stop')
  return _appendResponse(response)
}, error => {
  store.dispatch('loading/stop')
  return _appendResponse(error.response)
})

export {
  instance,
  Movimenta20Instance,
  DHLLabelInstance,
  SfpInstance
}



// WEBPACK FOOTER //
// ./src/repository/http.js